import React from 'react';
import { shape, string, oneOf, bool } from 'prop-types';
import BaseTile from 'components/tiles/BaseTile';
import CareerTile from 'components/tiles/CareerTile';
import HomeNewsTile from 'components/tiles/HomeNewsTile';
import ReducedTradeshowTile from 'components/tiles/ReducedTradeshowTile';
import BgImgTile from 'components/tiles/BgImgTile';
import NewsTile from 'components/tiles/NewsTile';
import TradeShowTile from 'components/tiles/TradeShowTile';
import LocationTile from 'components/tiles/LocationTile';
import BrochureListingTile from 'components/tiles/BrochureListingTile';
import ProductListingTile from 'components/tiles/ProductListingTile';

export default function ListingItem({
    item,
    itemType,
    itemDirection,
    handleOpenModal,
    viewMoreText,
    downloadText,
    meetUsText,
    viewProductText,
    columnName1,
    columnName2,
    columnName3,
    isEcowise
}) {
    // Determine which tile component gets rendered
    switch (itemType) {
        case 'bgimg':
            return <BgImgTile item={item} />;
        // add more below...
        case 'newsTile':
            return <NewsTile item={item} viewMoreText={viewMoreText} />;
        case 'TradeShowTile':
            return (
                <TradeShowTile
                    item={item}
                    viewMoreText={viewMoreText}
                    meetUsText={meetUsText}
                />
            );
        case 'LocationTile':
            return (
                <LocationTile
                    item={item}
                    handleOpenModal={handleOpenModal}
                    viewMoreText={viewMoreText}
                />
            );
        case 'BrochureListingTile':
            return (
                <BrochureListingTile
                    item={item}
                    downloadText={downloadText}
                    meetUsText={meetUsText}
                />
            );
        case 'ProductListingTile':
            return (
                <ProductListingTile
                    isEcowise={isEcowise}
                    item={item}
                    viewProductText={viewProductText}
                    viewMoreText={viewMoreText}
                    columnName1={columnName1}
                    columnName2={columnName2}
                    columnName3={columnName3}
                />
            );
        case 'careerTile':
            return (
                <CareerTile
                    item={item}
                    itemDirection={itemDirection}
                    viewMoreText={viewMoreText}
                />
            );
        case 'HomeNewsTile':
            return (
                <HomeNewsTile
                    item={item}
                    itemDirection={itemDirection}
                    viewMoreText={viewMoreText}
                />
            );
        case 'ReducedTradeshowTile':
            return (
                <ReducedTradeshowTile
                    item={item}
                    itemDirection={itemDirection}
                    viewMoreText={viewMoreText}
                />
            );
        default:
            return (
                <BaseTile
                    item={item}
                    itemDirection={itemDirection}
                    viewMoreText={viewMoreText}
                />
            );
    }
}

ListingItem.propTypes = {
    item: shape({ title: string.isRequired }).isRequired,
    itemType: string.isRequired,
    itemDirection: oneOf(['horizontal', 'vertical']),
    viewMoreText: string.isRequired,
    downloadText: string.isRequired,
    meetUsText: string.isRequired,
    viewProductText: string.isRequired,
    columnName1: string.isRequired,
    columnName2: string.isRequired,
    columnName3: string.isRequired,
    isEcowise: bool
};

ListingItem.defaultProps = { itemDirection: 'horizontal', isEcowise: false };
